export const enum DateDisplayTimeZone {
  CurrentTimeZone = "CurrentTimeZone",
  UTC = "UTC",
}
